import { createSelector } from "reselect";
import { Color } from "@evergis/color";
import { RootState } from "../reducers";
import { initialSettings, PrintState } from "./print";
import { LegendPosition, PrintType } from "../../interfaces/print";

export const GRID_DEFAULTS = {
  size: 1,
  color: new Color("#000"),
};

export const LEGEND_DEFAULTS = {
  placement: PrintType.MapWithLegend,
  position: LegendPosition.Left,
};

export const getPrintState = ({ print }: RootState): PrintState => print || ({} as PrintState);

export const getPrintRectangle = createSelector(getPrintState, ({ rectangle }) => rectangle || {});
export const getPrintSettings = createSelector(getPrintState, ({ settings }) => settings || initialSettings);
export const getPrintEnabled = createSelector(getPrintState, ({ enabled }) => enabled || false);

export const getPrintWithScale = createSelector(getPrintSettings, ({ withScale }) => withScale);
export const getPrintTitle = createSelector(getPrintSettings, ({ title }) => title);
export const getPrintGrid = createSelector(getPrintSettings, ({ grid }) => grid);
export const getPrintWithGrid = createSelector(getPrintGrid, grid => grid !== null);
export const getPrintWithTitle = createSelector(getPrintTitle, title => title !== null);
export const getPrintGridSize = createSelector(getPrintGrid, grid =>
  grid && grid.size !== undefined ? grid.size : GRID_DEFAULTS.size,
);
export const getPrintGridColor = createSelector(getPrintGrid, grid =>
  grid && grid.color !== undefined ? grid.color : GRID_DEFAULTS.color,
);
export const getPrintLegend = createSelector(getPrintSettings, ({ legend }) => legend);
export const getPrintWithLegend = createSelector(getPrintLegend, legend => legend !== null);
export const getPrintLegendPlacement = createSelector(getPrintLegend, legend =>
  legend && legend.placement !== undefined ? legend.placement : LEGEND_DEFAULTS.placement,
);
export const getPrintLegendPosition = createSelector(getPrintLegend, legend =>
  legend && legend.position !== undefined ? legend.position : LEGEND_DEFAULTS.position,
);
